import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, QueryList, Signal, ViewChild, ViewChildren, computed, effect, signal } from '@angular/core';
import { View } from 'src/app/interfaces/view';
import { Navigation2Service } from '../../services/navigation2.service';
import { SelectedAttributeService } from '../../services/selected-attribute.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})

export class ProgressBarComponent {
  @Input() indexedViews: View[] = [];
  @ViewChild('progressContainer') progressContainer!: ElementRef<HTMLDivElement>;
  containerWidth: string = '0px';
  activeVieiwIndex: number | null = null;
  largestPointy: number = 0;
  shouldShowRight = signal(true);
  shouldShowLeft = signal(false);
  @ViewChildren('pointy') pointies?: QueryList<ElementRef<HTMLDivElement>>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private navigationService: Navigation2Service,
    private selectedAttributeService: SelectedAttributeService
  ) {
    effect(() => {
      this.activeVieiwIndex = this.navigationService.activeViewIndex() ?? 0;
      this.largestPointy = this.activeVieiwIndex < this.indexedViews.length ? 0.4 : 1/7

      this.changeDetectorRef.detectChanges();

      if (this.pointies) {
        const activePointy = Array.from(this.pointies).find(p => p.nativeElement.classList.contains('ActiveIndex'))
        if (activePointy) {
          const activeRight = activePointy.nativeElement.offsetLeft + activePointy.nativeElement.clientWidth;
          const activeLeft = activePointy.nativeElement.offsetLeft;
          const containerVisibleLeftBound = this.progressContainer.nativeElement.scrollLeft;
          const containerVisibleRightBound = this.progressContainer.nativeElement.scrollLeft + this.progressContainer.nativeElement.clientWidth;


          const pointyIndex = +(activePointy.nativeElement.dataset['index'] ?? 0);
          if (pointyIndex === 0) {
            this.progressContainer.nativeElement.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (pointyIndex === this.pointies.length - 1) {
            this.progressContainer.nativeElement.scrollTo({ left: this.progressContainer.nativeElement.scrollWidth, behavior: 'smooth' });
          } else {
            this.progressContainer.nativeElement.scrollTo({ left: activeRight - activePointy.nativeElement.clientWidth / 2 - this.progressContainer.nativeElement.clientWidth / 2, behavior: 'smooth' });
          }

          // if (activeRight > containerVisibleRightBound) {
          //   this.progressContainer.nativeElement.scrollTo({ left: containerVisibleLeftBound + activeRight - containerVisibleRightBound, behavior: 'smooth' });
          // }

          // if (activeLeft < containerVisibleLeftBound) {
          //   this.progressContainer.nativeElement.scrollTo({ left: activeLeft, behavior: 'smooth' });
          // }
        }
      }
    });
  }

  // ngOnInit() {
  //   this.navigationService.subscribeActiveViewIndexChange(() => {
  //     this.activeVieiwIndex = this.navigationService.activeViewIndex ?? 0;
  //     this.largestPointy = this.activeVieiwIndex < this.indexedViews.length ? 0.4 : 1/7

  //     this.changeDetectorRef.detectChanges();

  //     if (this.pointies) {
  //       const activePointy = Array.from(this.pointies).find(p => p.nativeElement.classList.contains('ActiveIndex'))
  //       if (activePointy) {
  //         const activeRight = activePointy.nativeElement.offsetLeft + activePointy.nativeElement.clientWidth;
  //         const activeLeft = activePointy.nativeElement.offsetLeft;
  //         const containerVisibleLeftBound = this.progressContainer.nativeElement.scrollLeft;
  //         const containerVisibleRightBound = this.progressContainer.nativeElement.scrollLeft + this.progressContainer.nativeElement.clientWidth;


  //         const pointyIndex = +(activePointy.nativeElement.dataset['index'] ?? 0);
  //         if (pointyIndex === 0) {
  //           this.progressContainer.nativeElement.scrollTo({ left: 0, behavior: 'smooth' });
  //         } else if (pointyIndex === this.pointies.length - 1) {
  //           this.progressContainer.nativeElement.scrollTo({ left: this.progressContainer.nativeElement.scrollWidth, behavior: 'smooth' });
  //         } else {
  //           this.progressContainer.nativeElement.scrollTo({ left: activeRight - activePointy.nativeElement.clientWidth / 2 - this.progressContainer.nativeElement.clientWidth / 2, behavior: 'smooth' });
  //         }

  //         // if (activeRight > containerVisibleRightBound) {
  //         //   this.progressContainer.nativeElement.scrollTo({ left: containerVisibleLeftBound + activeRight - containerVisibleRightBound, behavior: 'smooth' });
  //         // }

  //         // if (activeLeft < containerVisibleLeftBound) {
  //         //   this.progressContainer.nativeElement.scrollTo({ left: activeLeft, behavior: 'smooth' });
  //         // }
  //       }
  //     }
  //   });
  // }

  ngAfterViewInit() {
    this.containerWidth = `${this.progressContainer.nativeElement.getBoundingClientRect().width}px`;
    this.changeDetectorRef.detectChanges();

    // this.progressContainer.nativeElement.addEventListener('touchmove', (e) => {
    //   const touchX = e.touches[0].clientX
    //   const offsetTouchX = touchX - this.progressContainer.nativeElement.getBoundingClientRect().width * 0.25;
    //   const hoveredPointy = Array.from(this.progressContainer.nativeElement.children).find(c => c.getBoundingClientRect().left >= offsetTouchX && offsetTouchX <= c.getBoundingClientRect().right);
    //   const hoveredIndex = (hoveredPointy as HTMLElement | undefined)?.dataset?.['index'];
    //   if (hoveredIndex && !isNaN(+hoveredIndex)) {
    //     this.activeVieiwIndex = +hoveredIndex;
    //     this.navigationService.navigateTo(this.activeVieiwIndex);
    //   }
    // });

    this.progressContainer.nativeElement.addEventListener('scroll', this.scroll.bind(this));
  }

  scroll() {
    const scrollRight = this.progressContainer.nativeElement.clientWidth - this.progressContainer.nativeElement.scrollWidth + this.progressContainer.nativeElement.scrollLeft;
    this.shouldShowRight.set(scrollRight !== 0)
    this.shouldShowLeft.set(this.progressContainer.nativeElement.scrollLeft !== 0)
  }

  progressItemClick(index: number) {
    this.navigationService.navigateTo(index);
  }

  doesSectionHaveSelection(sectionTitle: string) {
    const titles = {
      'Design': 'design',
      'Profile': 'form',
      'Edge Material': 'primaryMaterial',
      'Center Material': 'secondaryMaterial',
      'Width': 'width',
      'Finger Size': 'size'
    }

    if (sectionTitle.toLowerCase().includes('design') || sectionTitle.toLowerCase().includes('engraving')) {
      return true;
    }

    return (this.selectedAttributeService.configuredItem() as any)[(titles as any)[sectionTitle]] || (sectionTitle === 'Engraving' && this.selectedAttributeService.configuredItem().engravingText && this.selectedAttributeService.configuredItem().engravingType);
  }

  @HostListener('window:resize', [])
  windowResize() {
    this.containerWidth = `${this.progressContainer.nativeElement.getBoundingClientRect().width}px`;
  }
}
